import React, { useState, useEffect } from 'react';
import { Modal, Form, Row, Col, Button, Table, Card, Descriptions, Input } from 'antd';
import styles from './index.less'
import { print } from "@/utils/printUtils";
import moment from 'moment'

const { TextArea } = Input;

const PrintModal = ({
  taskDetail = {},
  infos = {},
  type,
  ...other
}) => {
  const [info, setInfo] = useState({})

  useEffect(() => {
    if (infos) {
      setInfo({ ...infos })
    }
  }, [infos])

  const handlePrint = () => {
    const printContent = document.getElementById("printDetails").parentNode;
    setTimeout(() => {
      print(printContent);
    }, 1500);
  }

  const modalProps = {
    visible: true,
    // onCancel,
    width: 800,
    okText: '打印',
    ...other
  };

  if (type === 'view') {
    modalProps.footer = null
  }

  const handleChange = (key, value) => {
    let newInfo = { ...info }
    newInfo[key] = value
    setInfo({ ...newInfo })
  }

  return (
    // <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>

    // </Modal>
    <Modal {...modalProps} closable={false} title='' onOk={() => handlePrint()}>
      <div id='printDetails'>
        <div className={styles.BSPPrint} id='printDetails'>
          <h2 style={{ textAlign: 'center' }}>沙盘影射分析记录表</h2>
          <div>
            <Descriptions bordered>
              <Descriptions.Item span={1} label="评估分析结果">{info.evaluationAnalysisResult}</Descriptions.Item>
              <Descriptions.Item span={1} label="日期时间">{info.documentDate && moment(info.documentDate).format('YYYY-MM-DD HH:mm:ss')}</Descriptions.Item>
              <Descriptions.Item span={1} label="次数">第{info.count}次</Descriptions.Item>
            </Descriptions>
          </div>
          <div className={styles.bspCommontContain}>
            <Descriptions bordered column={1}>
              <Descriptions.Item label="阶段目标"><div style={{ padding: '8px 16px' }}>
                <TextArea value={info.stageGoal} autoSize={{ minRows: 1 }} onChange={e => handleChange('stageGoal', e.target.value)} />
              </div></Descriptions.Item>
              <Descriptions.Item label="本次目标"><div style={{ padding: '8px 16px' }}>
                <TextArea value={info.theTarget} autoSize={{ minRows: 1 }} onChange={e => handleChange('theTarget', e.target.value)} />
              </div></Descriptions.Item>
              {info.sandTablePicture && <Descriptions.Item label="沙盘图片"><div style={{ padding: '8px 16px', minHeight: 180 }} dangerouslySetInnerHTML={{ __html: info.sandTablePicture }}></div></Descriptions.Item>}
              {info.interpretationOfTheAnalysis && <Descriptions.Item label="解读分析"><div style={{ padding: '8px 16px', minHeight: 180 }}>{info.interpretationOfTheAnalysis}
                <TextArea value={info.interpretationOfTheAnalysis} autoSize={{ minRows: 1 }} onChange={e => handleChange('interpretationOfTheAnalysis', e.target.value)} />
              </div></Descriptions.Item>}
              {info.specialEvent && <Descriptions.Item label="特别事件"><div style={{ padding: '8px 16px' }}>
                <TextArea value={info.specialEvent} autoSize={{ minRows: 1 }} onChange={e => handleChange('specialEvent', e.target.value)} />
              </div></Descriptions.Item>}
              {info.problems && <Descriptions.Item label="问题困扰"><div style={{ padding: '8px 16px' }}>
                <TextArea value={info.problems} autoSize={{ minRows: 1 }} onChange={e => handleChange('problems', e.target.value)} />
              </div></Descriptions.Item>}
              {info.reservedHomework && <Descriptions.Item label="预留作业"><div style={{ padding: '8px 16px' }}>
                <TextArea value={info.reservedHomework} autoSize={{ minRows: 1 }} onChange={e => handleChange('reservedHomework', e.target.value)} />
              </div></Descriptions.Item>}
              {info.supplementInfo && <Descriptions.Item label="其他情况补充记录"><div style={{ padding: '8px 16px' }} dangerouslySetInnerHTML={{ __html: info.supplementInfo }}></div></Descriptions.Item>}
            </Descriptions>
          </div>
        </div>
      </div>
    </Modal>

  );
};

export default Form.create()(PrintModal);
